exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__container___2k8nm{background:#fed230;border-radius:5px;padding:1rem;display:flex;flex-direction:column;justify-content:space-between}.index-module__container___2k8nm.index-module__home___3e3Vr{margin-top:1rem}@media (min-width:525px){.index-module__container___2k8nm.index-module__home___3e3Vr{margin-bottom:1rem}}@media (min-width:1325px){.index-module__container___2k8nm.index-module__home___3e3Vr{margin-bottom:-1rem}}.index-module__container___2k8nm .index-module__wrapper___1Ah3t{display:grid;grid-template-rows:auto;row-gap:.8rem;padding:.2rem .2rem 2rem}.index-module__container___2k8nm .index-module__btn___1GV2W{display:flex;padding:.6rem .4rem}", ""]);

// exports
exports.locals = {
	"container": "index-module__container___2k8nm",
	"home": "index-module__home___3e3Vr",
	"wrapper": "index-module__wrapper___1Ah3t",
	"btn": "index-module__btn___1GV2W"
};